import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { flare } from '@flareapp/js';

@Injectable()
export class FlareErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const reported = error?.rejection ?? error?.originalError ?? error;
    if (reported instanceof HttpErrorResponse) {
      console.error(error);
      return;
    }
    try {
      flare.report(reported);
    } catch {}
    console.error(error);
  }
}
